import React from 'react';
import { SeasonPlayerRanking, SeasonRankings } from '../../../types/types';
import { getTopPercent, STAT_LABELS } from './achievementUtils';
import Medal from './Medal';

interface AchievementShowcaseProps {
    rankings: SeasonRankings;
    seasons: number[];
}

const AchievementShowcase: React.FC<AchievementShowcaseProps> = ({ rankings, seasons }) => {
    // Collect all rankings into a flat array and find the top 3 by lowest rank
    const allRankings: (SeasonPlayerRanking & { key: string })[] = [];

    for (const season of seasons) {
        const seasonRankings = rankings[season];
        if (!seasonRankings) continue;
        for (const r of seasonRankings) {
            allRankings.push({ ...r, key: `${r.season}-${r.stat}` });
        }
    }

    // Sort by rank ascending (best first), take top 3
    const best = allRankings
        .sort((a, b) => a.rank - b.rank)
        .slice(0, 3);

    if (best.length === 0) return null;

    return (
        <div className="showcase-section">
            <div className="showcase-title">Bedste Placeringer</div>
            <div className="showcase-cards">
                {best.map((ranking) => {
                    const statLabel = STAT_LABELS[ranking.stat];
                    const topPct = getTopPercent(ranking.rank, ranking.totalPlayers);

                    return (
                        <div key={ranking.key} className="showcase-item">
                            <Medal
                                rank={ranking.rank}
                                totalPlayers={ranking.totalPlayers}
                                stat={ranking.stat}
                                showLabel={false}
                                scale={1.4}
                            />
                            <div className="showcase-item__info">
                                <div className="showcase-item__stat">
                                    {statLabel?.short || ranking.stat}
                                </div>
                                <div className="showcase-item__season">
                                    Saeson {ranking.season}
                                </div>
                                <div className="showcase-item__percentile">
                                    {topPct}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AchievementShowcase;
